import { Input } from "@digital-services/ui";

interface Props {
  id: string;
  label: string;
  initialEmailValue: string | undefined;
}

// Note that this component created for simple, readonly usage (no context)
export const ReadonlyUserEmail = (props: Props) => {
  const { id, label, initialEmailValue } = props;

  return (
    <Input
      type="email"
      id={id}
      data-testid={id}
      label={label}
      value={initialEmailValue}
      disabled={true}
      autoComplete="off" // string value should be standard HTML value
    />
  );
};
